import { Checkbox, Grid, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { BusinessTypes } from '../../../../enums/business-type';
import { UpdateMerchantOnboardingFormValues } from '../../../../type/update-merchant-onboarding-form-values.types';

interface UpdateSignatoryProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  index: number;
}
function UpdateSignatory(props: UpdateSignatoryProps) {
  const { form, index } = props;
  const label = {
    signatoryFirstName: 'First name',
    signatoryMiddleName: 'Middle name',
    signatoryHasMiddleName: "I don't have a middle name",
    signatoryLastName: 'Last name',
    signatoryPosition: 'Position',
    copyProToSignatory: 'Use same details as the proprietor',
  };
  const placeHolder = {
    signatoryFirstName: 'First name',
    signatoryMiddleName: 'Middle name',
    signatoryLastName: 'Last name',
    signatoryPosition: 'Position',
  };

  return (
    <>
      <Grid>
        {index === 0 &&
          form.values.businessTypeId === BusinessTypes.SOLE_PROPRIETOR &&
          form.values.incorporators &&
          form.values.incorporators.length > 0 && (
            <Grid.Col>
              <Checkbox
                label={label.copyProToSignatory}
                {...form.getInputProps('copyProToSignatory', {
                  type: 'checkbox',
                })}
                // data-cy="copyProToSignatory"
              />
            </Grid.Col>
          )}
        {!(
          index === 0 &&
          form.values.copyProToSignatory &&
          form.values.incorporators &&
          form.values.incorporators.length > 0 &&
          form.values.businessTypeId === BusinessTypes.SOLE_PROPRIETOR
        ) && (
          <>
            <Grid.Col>
              <TextInput
                placeholder={placeHolder.signatoryFirstName}
                label={label.signatoryFirstName}
                {...form.getListInputProps('signatories', index, 'firstName')}
                data-cy='firstName'
              />
            </Grid.Col>
            <Grid.Col>
              <TextInput
                placeholder={placeHolder.signatoryMiddleName}
                label={label.signatoryMiddleName}
                disabled={!form.values.signatories[index].hasMiddleName}
                {...form.getListInputProps('signatories', index, 'middleName')}
                data-cy='middleName'
              />
            </Grid.Col>
            <Grid.Col>
              <Checkbox
                label={label.signatoryHasMiddleName}
                checked={!form.values.signatories[index].hasMiddleName}
                onChange={(event) => {
                  form.setListItem('signatories', index, {
                    ...form.values.signatories[index],
                    hasMiddleName: !event.currentTarget.checked,
                    middleName: event.currentTarget.checked ? '.' : '',
                  });
                }}
                data-cy='hasMiddleName'
              />
            </Grid.Col>
            <Grid.Col>
              <TextInput
                placeholder={placeHolder.signatoryLastName}
                label={label.signatoryLastName}
                {...form.getListInputProps('signatories', index, 'lastName')}
                data-cy='lastName'
              />
            </Grid.Col>
          </>
        )}
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.signatoryPosition}
            label={label.signatoryPosition}
            {...form.getListInputProps('signatories', index, 'position')}
            data-cy='position'
          />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default UpdateSignatory;
